var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('p',{staticStyle:{"font-size":"30px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('person-search',{on:{"change":_vm.selectAndClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }